// import Form from 'react-bootstrap/Form';
// import Container from 'react-bootstrap/Container';
// import Stack from 'react-bootstrap/Stack';
// import Col from 'react-bootstrap/Col';
// import Row from 'react-bootstrap/Row';
// import Button from 'react-bootstrap/Button';
// import { useState, useEffect } from "react";
// import { readProctorAvailability, updateProctorAvailability, deleteProctor } from '../../control/proctorAvailabilityData'; // Firebase functions
// import { useNavigate } from 'react-router-dom';
//
// function EditProctor() {
//     const [proctors, setProctors] = useState([]);
//     const [selectedProctor, setSelectedProctor] = useState("");
//     const [availability, setAvailability] = useState({
//         Monday: { selected: false, startTime: "", endTime: "" },
//         Tuesday: { selected: false, startTime: "", endTime: "" },
//         Wednesday: { selected: false, startTime: "", endTime: "" },
//         Thursday: { selected: false, startTime: "", endTime: "" },
//         Friday: { selected: false, startTime: "", endTime: "" },
//     });
//
//     const navigate = useNavigate();
//
//     useEffect(() => {
//         const fetchProctors = async () => {
//             const availabilityList = await readProctorAvailability();
//             setProctors(availabilityList);
//         };
//         fetchProctors();
//     }, []);
//
//     useEffect(() => {
//         const handleKeyPress = (e) => {
//             if (e.key === 'ArrowLeft') {
//                 navigate("/AdministratorDashboard");
//             }
//         };
//
//         window.addEventListener("keydown", handleKeyPress);
//         return () => {
//             window.removeEventListener("keydown", handleKeyPress);
//         };
//     }, [navigate]);
//
//     const handleProctorSelect = (e) => {
//         const proctorFullName = e.target.value;
//         setSelectedProctor(proctorFullName);
//
//         if (proctorFullName) {
//             const proctorData = proctors.find((proctor) => `${proctor.proctorFirstName} ${proctor.proctorLastName}` === proctorFullName);
//             if (proctorData) {
//                 setAvailability(proctorData.availability);
//             }
//         } else {
//             setAvailability({
//                 Monday: { selected: false, startTime: "", endTime: "" },
//                 Tuesday: { selected: false, startTime: "", endTime: "" },
//                 Wednesday: { selected: false, startTime: "", endTime: "" },
//                 Thursday: { selected: false, startTime: "", endTime: "" },
//                 Friday: { selected: false, startTime: "", endTime: "" },
//             });
//         }
//     };
//
//     const handleDayChange = (day) => {
//         setAvailability({
//             ...availability,
//             [day]: { ...availability[day], selected: !availability[day].selected, startTime: "", endTime: "" },
//         });
//     };
//
//     const handleStartTime = (day, e) => {
//         setAvailability({
//             ...availability,
//             [day]: { ...availability[day], startTime: e.target.value, endTime: "" },
//         });
//     };
//
//     const handleEndTime = (day, e) => {
//         setAvailability({
//             ...availability,
//             [day]: { ...availability[day], endTime: e.target.value },
//         });
//     };
//
//     const isValid = Object.keys(availability).every((day) => {
//         if (availability[day].selected) {
//             return availability[day].startTime && availability[day].endTime;
//         }
//         return true;
//     });
//
//     const handleSaveChanges = async () => {
//         if (!isValid) {
//             alert("You must select start and end times for all selected days.");
//             return;
//         }
//
//         if (selectedProctor) {
//             await updateProctorAvailability(selectedProctor, availability);
//             navigate("/editproctorsuccess");
//         }
//     };
//
//     const handleDeleteProctor = async () => {
//         if (selectedProctor) {
//             try {
//                 await deleteProctor(selectedProctor);
//                 setProctors(proctors.filter((proctor) => `${proctor.proctorFirstName} ${proctor.proctorLastName}` !== selectedProctor));
//                 setSelectedProctor("");
//                 setAvailability({
//                     Monday: { selected: false, startTime: "", endTime: "" },
//                     Tuesday: { selected: false, startTime: "", endTime: "" },
//                     Wednesday: { selected: false, startTime: "", endTime: "" },
//                     Thursday: { selected: false, startTime: "", endTime: "" },
//                     Friday: { selected: false, startTime: "", endTime: "" },
//                 });
//
//                 alert('Proctor deleted successfully');
//                 navigate("/AdministratorDashboard", { state: { toProctor: true } });
//             } catch (error) {
//                 console.error('Error deleting proctor:', error);
//                 alert('There was an error deleting the proctor.');
//             }
//         } else {
//             alert('Please select a proctor first');
//         }
//     };
//
//     return (
//       <div className="d-flex justify-content-center align-items-center min-vh-100">
//           <Container className="centered-form rounded position-relative">
//               {/* Back button positioned at the top-right */}
//               <Button
//                 variant="outline-secondary"
//                 className="position-absolute top-0 end-0 m-3"
//                 onClick={() => navigate("/AdministratorDashboard")}
//               >
//                   ← Back
//               </Button>
//
//               <Form onSubmit={(e) => {
//                   e.preventDefault();
//                   handleSaveChanges();
//               }}>
//                   <h2 className="text-center my-4">Edit Proctor Availability</h2>
//
//                   <Form.Group className="mb-3">
//                       <Form.Label>Proctor</Form.Label>
//                       <Form.Control as="select" value={selectedProctor} onChange={handleProctorSelect}>
//                           <option value="" disabled>Select Proctor Name</option>
//                           {proctors.map((proctor) => (
//                             <option key={proctor.id} value={`${proctor.proctorFirstName} ${proctor.proctorLastName}`}>
//                                 {proctor.proctorFirstName} {proctor.proctorLastName}
//                             </option>
//                           ))}
//                       </Form.Control>
//                   </Form.Group>
//
//                   <Form.Group className="mb-3">
//                       <Form.Label>Select the Availability Days</Form.Label>
//                       {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((day) => (
//                         <Stack key={day} gap={4}>
//                             <div>
//                                 <Form.Check
//                                   type="checkbox"
//                                   label={day}
//                                   checked={availability[day].selected}
//                                   onChange={() => handleDayChange(day)}
//                                   disabled={!selectedProctor}
//                                 />
//                             </div>
//                         </Stack>
//                       ))}
//                   </Form.Group>
//
//                   <div className="d-flex justify-content-between">
//                       <Button variant="danger" onClick={handleDeleteProctor} disabled={!selectedProctor}>
//                           Delete Proctor
//                       </Button>
//                       <Button type="submit" variant="primary" disabled={!isValid || !selectedProctor}>
//                           Save Changes
//                       </Button>
//                   </div>
//               </Form>
//           </Container>
//       </div>
//     );
//
//
// }
//
// export default EditProctor;
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Stack from "react-bootstrap/Stack";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import {
    readProctorAvailability,
    updateProctorAvailability,
    deleteProctor,
} from "../../control/proctorAvailabilityData";

function EditProctor() {
    const [proctors, setProctors] = useState([]);
    const [selectedProctor, setSelectedProctor] = useState("");
    const [availability, setAvailability] = useState({
        Monday: { selected: false, startTime: "", endTime: "" },
        Tuesday: { selected: false, startTime: "", endTime: "" },
        Wednesday: { selected: false, startTime: "", endTime: "" },
        Thursday: { selected: false, startTime: "", endTime: "" },
        Friday: { selected: false, startTime: "", endTime: "" },
    });

    const navigate = useNavigate();

    useEffect(() => {
        const fetchProctors = async () => {
            const availabilityList = await readProctorAvailability();
            setProctors(availabilityList);
        };
        fetchProctors();
    }, []);

    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === "ArrowLeft") {
                navigate("/AdministratorDashboard");
            }
        };

        window.addEventListener("keydown", handleKeyPress);
        return () => {
            window.removeEventListener("keydown", handleKeyPress);
        };
    }, [navigate]);

    const handleProctorSelect = (e) => {
        const proctorFullName = e.target.value;
        setSelectedProctor(proctorFullName);

        if (proctorFullName) {
            const proctorData = proctors.find(
              (proctor) =>
                `${proctor.proctorFirstName} ${proctor.proctorLastName}` ===
                proctorFullName
            );
            if (proctorData) {
                setAvailability(proctorData.availability);
            }
        } else {
            resetAvailability();
        }
    };

    const resetAvailability = () => {
        setAvailability({
            Monday: { selected: false, startTime: "", endTime: "" },
            Tuesday: { selected: false, startTime: "", endTime: "" },
            Wednesday: { selected: false, startTime: "", endTime: "" },
            Thursday: { selected: false, startTime: "", endTime: "" },
            Friday: { selected: false, startTime: "", endTime: "" },
        });
    };

    const handleDayChange = (day) => {
        setAvailability((prev) => ({
            ...prev,
            [day]: {
                ...prev[day],
                selected: !prev[day].selected,
                startTime: "",
                endTime: "",
            },
        }));
    };

    const handleStartTime = (day, e) => {
        setAvailability((prev) => ({
            ...prev,
            [day]: {
                ...prev[day],
                startTime: e.target.value,
                endTime: "",
            },
        }));
    };

    const handleEndTime = (day, e) => {
        setAvailability((prev) => ({
            ...prev,
            [day]: {
                ...prev[day],
                endTime: e.target.value,
            },
        }));
    };

    const isValid = Object.keys(availability).every((day) => {
        if (availability[day].selected) {
            return availability[day].startTime && availability[day].endTime;
        }
        return true;
    });

    const handleSaveChanges = async () => {
        if (!isValid) {
            alert("You must select start and end times for all selected days.");
            return;
        }

        if (selectedProctor) {
            await updateProctorAvailability(selectedProctor, availability);
            navigate("/editproctorsuccess");
        }
    };

    const handleDeleteProctor = async () => {
        if (selectedProctor) {
            try {
                await deleteProctor(selectedProctor);
                setProctors((prev) =>
                  prev.filter(
                    (proctor) =>
                      `${proctor.proctorFirstName} ${proctor.proctorLastName}` !==
                      selectedProctor
                  )
                );
                setSelectedProctor("");
                resetAvailability();
                alert("Proctor deleted successfully");
                navigate("/AdministratorDashboard", { state: { toProctor: true } });
            } catch (error) {
                console.error("Error deleting proctor:", error);
                alert("There was an error deleting the proctor.");
            }
        } else {
            alert("Please select a proctor first");
        }
    };

    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100">
          <Container className="centered-form rounded position-relative">
              <Button
                variant="outline-secondary"
                className="position-absolute top-0 end-0 m-3"
                onClick={() => navigate("/AdministratorDashboard")}
              >
                  ← Back
              </Button>

              <Form
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSaveChanges();
                }}
              >
                  <h2 className="text-center my-4">Edit Proctor Availability</h2>

                  <Form.Group className="mb-3">
                      <Form.Label>Proctor</Form.Label>
                      <Form.Control
                        as="select"
                        value={selectedProctor}
                        onChange={handleProctorSelect}
                      >
                          <option value="" disabled>
                              Select Proctor Name
                          </option>
                          {proctors.map((proctor) => (
                            <option
                              key={proctor.id}
                              value={`${proctor.proctorFirstName} ${proctor.proctorLastName}`}
                            >
                                {proctor.proctorFirstName} {proctor.proctorLastName}
                            </option>
                          ))}
                      </Form.Control>
                  </Form.Group>

                  <Form.Group className="mb-3">
                      <Form.Label>Select the Availability Days</Form.Label>
                      {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map(
                        (day) => (
                          <div key={day}>
                              <Form.Check
                                type="checkbox"
                                label={day}
                                checked={availability[day].selected}
                                onChange={() => handleDayChange(day)}
                                disabled={!selectedProctor}
                              />
                              {availability[day].selected && (
                                <Row className="mt-2 mb-3">
                                    <Col>
                                        <Form.Label>Start Time</Form.Label>
                                        <Form.Control
                                          type="time"
                                          value={availability[day].startTime}
                                          onChange={(e) => handleStartTime(day, e)}
                                        />
                                    </Col>
                                    <Col>
                                        <Form.Label>End Time</Form.Label>
                                        <Form.Control
                                          type="time"
                                          value={availability[day].endTime}
                                          onChange={(e) => handleEndTime(day, e)}
                                        />
                                    </Col>
                                </Row>
                              )}
                          </div>
                        )
                      )}
                  </Form.Group>

                  <div className="d-flex justify-content-between">
                      <Button
                        variant="secondary"
                        onClick={handleDeleteProctor}
                        disabled={!selectedProctor}
                      >
                          Delete Proctor
                      </Button>
                      <Button
                        type="submit"
                        variant="success"
                        disabled={!isValid || !selectedProctor}
                      >
                          Save Changes
                      </Button>
                  </div>
              </Form>
          </Container>
      </div>
    );
}

export default EditProctor;
